import { useEffect, useState } from "react";
import { AreaChart, Area, PieChart, Pie, Cell, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { api } from "@/lib/api";
import { fmtTime } from "@/lib/api";

const PIE_COLORS = ["#1e88ff", "#60a5fa", "#bfdbfe"];

const fmtHrs = (sec = 0) => { const h = Math.floor(sec / 3600); const m = Math.floor((sec % 3600) / 60); return h ? `${h} മ.${m} മി.` : `${m} മി.`; };

const OnlineHoursTable = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { const f = () => api.get("/admin/staff-online-hours", { params: { days: 7 } }).then((res) => setRows(res.data)).catch(() => null); f(); const t = setInterval(f, 30000); return () => clearInterval(t); }, []);
  if (!rows) return null;
  const max = Math.max(1, ...rows.map((r) => r.total_seconds));
  return (
    <div data-testid="online-hours-report" className="card rounded-2xl p-5 lg:col-span-2">
      <p className="label-caps mb-3">സ്റ്റാഫ് ഓൺലൈൻ സമയം — അവസാന 7 ദിവസം</p>
      {!rows.length ? <p className="text-xs text-[var(--muted-text)]">ഇതുവരെ ഓൺലൈൻ ഡാറ്റ ഇല്ല — സ്റ്റാഫ് ലോഗിൻ ചെയ്ത ശേഷം ഇവിടെ കാണാം</p> : (
        <div className="overflow-x-auto"><table className="w-full text-xs">
          <thead><tr className="text-left text-[var(--muted-text)]"><th className="pb-2 pr-3 font-semibold">സ്റ്റാഫ്</th><th className="pb-2 pr-3 font-semibold">ഇന്ന്</th><th className="pb-2 pr-3 font-semibold">7 ദിവസം ആകെ</th><th className="pb-2 font-semibold w-1/3"></th></tr></thead>
          <tbody>{rows.map((r) => (
            <tr key={r.staff_id} data-testid={`online-hours-${r.staff_id}`} className="border-t border-[var(--line)]">
              <td className="py-2 pr-3 font-semibold">{r.name}</td>
              <td className="py-2 pr-3 font-num text-emerald-600 font-bold">{fmtHrs(r.today_seconds)}</td>
              <td className="py-2 pr-3 font-num">{fmtHrs(r.total_seconds)}</td>
              <td className="py-2"><div className="h-2 rounded-full bg-slate-100"><div className="h-2 rounded-full bg-[var(--accent-c)]" style={{ width: `${Math.round((r.total_seconds / max) * 100)}%` }} /></div></td>
            </tr>))}
          </tbody></table></div>)}
    </div>
  );
};

export const AdminReports = () => {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/admin/report").then((res) => setR(res.data)).catch(() => null); }, []);
  if (!r) return <p className="text-[var(--muted-text)]">ലോഡ് ചെയ്യുന്നു...</p>;
  const pie = [
    { name: "Video", value: r.call_type.video, pct: r.call_type.video_pct },
    { name: "Audio", value: r.call_type.audio, pct: r.call_type.audio_pct },
    { name: "Chat", value: r.call_type.chat, pct: r.call_type.chat_pct },
  ];
  return (
    <div data-testid="admin-reports" className="grid lg:grid-cols-[1.3fr_1fr] gap-4">
      <div className="card rounded-2xl p-5">
        <p className="label-caps mb-4">Revenue Overview — അവസാന 7 ദിവസം</p>
        <div className="h-56">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={r.revenue_series}>
              <defs><linearGradient id="rev" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#1e88ff" stopOpacity={0.35} /><stop offset="100%" stopColor="#1e88ff" stopOpacity={0.02} /></linearGradient></defs>
              <XAxis dataKey="day" tick={{ fill: "#64748b", fontSize: 11 }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fill: "#64748b", fontSize: 11 }} axisLine={false} tickLine={false} />
              <Tooltip contentStyle={{ background: "#ffffff", border: "1px solid #dbe7f5", borderRadius: 12, color: "#1e2a38" }} formatter={(v) => [`₹${v}`, "വരുമാനം"]} />
              <Area type="monotone" dataKey="inr" stroke="#1e88ff" strokeWidth={2.5} fill="url(#rev)" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="card rounded-2xl p-5">
        <p className="label-caps mb-2">Call Type — 7 ദിവസം</p>
        <div className="h-44">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart><Pie data={pie} dataKey="value" innerRadius={52} outerRadius={72} paddingAngle={3} strokeWidth={0}>{pie.map((_, i) => <Cell key={i} fill={PIE_COLORS[i]} />)}</Pie><Tooltip formatter={(v, n) => [fmtTime(v), n]} contentStyle={{ background: "#ffffff", border: "1px solid #dbe7f5", borderRadius: 12 }} /></PieChart>
          </ResponsiveContainer>
        </div>
        <ul className="space-y-1.5 mt-2">
          {pie.map((p, i) => <li key={p.name} className="flex items-center gap-2 text-xs"><span className="w-2.5 h-2.5 rounded-full" style={{ background: PIE_COLORS[i] }} />{p.name}<span className="ml-auto font-num font-bold">{p.pct}%</span></li>)}
        </ul>
      </div>
      <OnlineHoursTable />
    </div>
  );
};
